import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { CapabilityView } from '../../../models/employee/CapabilityView';
import { CapabilityViewResponse } from '../../../../interfaces/response/EmployeeResponse';
import { EmployeePositionId } from '../../../models/employee/Employee';
import { CapabilityViewType } from '../../../enums/CapabilityViewType';

/**
 * An adapter converts capability view HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class CapabilityViewAdapter implements Adapter<CapabilityView[]> {
  /**
   * Converts capability view HTTP response to a list of {@link CapabilityView}.
   * @param item capability view HTTP response.
   */
  adapt(item: CapabilityViewResponse[]): CapabilityView[] {
    if (!item) {
      return [];
    }
    const result: CapabilityView[] = [];
    const capabilityTypesMap = getCapabilityTypesMap();
    item.forEach($item => {
        const capabilityView = new CapabilityView(
          capabilityTypesMap.get($item.requiredCapability),
          $item.date,
          $item.startTime,
          $item.endTime,
          $item.availableEmployees.map($availableEmployee => new EmployeePositionId(
            $availableEmployee.itrentEmployeeId,
            $availableEmployee.itrentPositionId
          )),
          $item.requiredEmployees
        );
        result.push(capabilityView);
      }
    );
    return result;
  }
}

function getCapabilityTypesMap(): Map<string, CapabilityViewType> {
  const capabilityTypeValues = new Map<string, CapabilityViewType>();
  capabilityTypeValues.set('BANKING', CapabilityViewType.BANKING);
  capabilityTypeValues.set('KEY_HOLDER', CapabilityViewType.KEY_HOLDER);
  capabilityTypeValues.set('FURNITURE_CHANGEOVER', CapabilityViewType.FURNITURE_CHANGEOVER);
  capabilityTypeValues.set('SALESPERSON', CapabilityViewType.SALESPERSON);
  capabilityTypeValues.set('SHOP_OPENER', CapabilityViewType.SHOP_OPENER);
  capabilityTypeValues.set('SHOP_CLOSER', CapabilityViewType.SHOP_CLOSER);
  capabilityTypeValues.set('CHANGEOVER_MANAGER', CapabilityViewType.CHANGEOVER_MANAGER);
  return capabilityTypeValues;
}
